import React from 'react'
import './loader.css'

const Loader = () => {
  return (
    <div className=' flex justify-center items-center h-[100vh] w-full'>

<div class="loader">Loading
  <span></span>
</div>
    </div>
  )
}

export default Loader
